import { paths } from "@rms-types/constants/paths";
import { useLocation, useNavigate } from "react-router";

import { useCreateConversation } from "../../hooks/api";
import { ConversationCreateForm, ConversationCreateFormProps } from "../conversation-create-form";

import { useDashboardSidebarStore, useModalStore } from "@/hooks";

interface ConversationCreateModalProps extends Omit<ConversationCreateFormProps, "onSubmit" | "loading" | "hideTo"> {
  subdomain?: string | null;
}

export function ConversationCreateModal({ subdomain, ...formProps }: ConversationCreateModalProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const { popModal } = useModalStore((state) => state.actions);
  const {
    actions: { refetchConversationSidebar },
  } = useDashboardSidebarStore();
  const { createConversation, isCreateConversationPending } = useCreateConversation({
    subdomain,
    options: {
      onSuccess: (data) => {
        popModal();
        refetchConversationSidebar();
        if (location.pathname.includes("message")) {
          navigate(paths.app.messages.inbox.conversation.details.getLink(data.id));
        }
      },
    },
  });

  return (
    <ConversationCreateForm
      hideTo={!!subdomain} // Hide the "To" field if subdomain is provided, it means that it's an external conversation
      loading={isCreateConversationPending}
      onSubmit={(values) => {
        createConversation({ payload: values });
      }}
      {...formProps}
    />
  );
}
